export type StatsOnboardPrintFilters = {
  vesselId?: string;
};

export function statsOnboardPrintPath(filters: StatsOnboardPrintFilters = {}): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  const s = qs.toString();
  return `/crew/reports/operations/onboard/print${s ? `?${s}` : ''}`;
}

/** Same statistics payload the ops page uses (vessel filter; period defaults unused for onboard). */
export function statsOnboardListApiUrl(params: URLSearchParams): string {
  const today = new Date().toISOString().slice(0, 10);
  const qs = new URLSearchParams({
    withinDays: '90',
    periodFrom: today,
    periodTo: today,
  });
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/statistics?${qs.toString()}`;
}

export function statsOnboardBackPath(): string {
  return '/crew/reports/operations/onboard';
}
